var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_56046)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4732 3.21547C14.5659 2.66255 13.4324 2.66255 12.5251 3.21549L4.19021 8.29497C3.32723 8.82088 2.79922 9.76814 2.79922 10.7904V15.3667C2.79922 15.8705 3.31044 16.2187 3.80428 16.119C4.19038 16.0409 4.58992 16 4.99902 16C8.31273 16 10.999 18.6863 10.999 22C10.999 22.7158 10.8737 23.4023 10.6438 24.0388C10.4526 24.5679 10.8086 25.2008 11.3712 25.2008H22.3341C23.9165 25.2008 25.1992 23.898 25.1992 22.2907V10.7904C25.1992 9.76814 24.6712 8.82088 23.8082 8.29496L15.4732 3.21547ZM19.8128 11.6724C19.5653 11.3133 19.0781 11.2259 18.7245 11.4774C16.8651 12.7993 15.8227 13.5405 13.9633 14.8625L9.20211 11.4774C8.84861 11.2259 8.36133 11.3133 8.11389 11.6724C7.86634 12.0314 7.9524 12.5264 8.30591 12.7777L13.5152 16.4815C13.7842 16.6728 14.1424 16.6728 14.4114 16.4815L19.6207 12.7777C19.9743 12.5264 20.0602 12.0314 19.8128 11.6724Z",
    fill: "#0FAF71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00130177 22.3698C-0.00130177 23.2448 0.243698 24.0731 0.675364 24.7731C1.48036 26.1265 2.96203 27.0365 4.66536 27.0365C6.3687 27.0365 7.85036 26.1265 8.65536 24.7731C9.08703 24.0731 9.33203 23.2448 9.33203 22.3698C9.33203 19.7915 7.2437 17.7031 4.66536 17.7031C2.08703 17.7031 -0.00130177 19.7915 -0.00130177 22.3698ZM7.11302 20.9032C7.2898 21.1153 7.26114 21.4306 7.049 21.6074L4.29731 23.9005C4.09864 24.066 3.80652 24.0528 3.62366 23.8699L2.24781 22.4941C2.05255 22.2988 2.05255 21.9822 2.24781 21.787C2.44308 21.5917 2.75966 21.5917 2.95492 21.787L4.0079 22.8399L6.40881 20.8392C6.62095 20.6624 6.93623 20.6911 7.11302 20.9032Z",
    fill: "#0FAF71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_56046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteSuccess);
export default __webpack_public_path__ + "static/media/quote-success.733274c1d35a68b3e14300796ba5b35c.svg";
export { ForwardRef as ReactComponent };